export default __webpack_public_path__ + "static/media/lluvioso.104fb269.gif";